/**
* Copyright (c) 2019 Vendor Badge, LLC All Rights Reserved.
* Created Date: Sunday, 24th March 2019
* 
*  Custom Themed MUI TextField that accepts props, input patterns, and has validation
*/
import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import { withStyles } from '@material-ui/core/styles';

// Material UI Components
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';

/**
 * Example Validation Patterns
 * OWASP Input Cheat Sheet
 * https://github.com/OWASP/CheatSheetSeries/blob/master/cheatsheets/Input_Validation_Cheat_Sheet.md
 * 
 * Country Code: pattern='[A-Za-z]{3}'
 * password (8 or more characters at least one number and one uppercase and lowercase letters): pattern='(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}'
 * tel: pattern='^\D?(\d{3})\D?\D?(\d{3})\D?(\d{4})$'
 * email: pattern='[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$'
 * url: pattern='https?://.+'
 * ZipCode Zip4 Optional: pattern='^\d{5}(-\d{4})?$'
 * State Abbreviation: pattern='^(AA|AE|AP|AL|AK|AS|AZ|AR|CA|CO|CT|DE|DC|FM|FL|GA|GU|HI|ID|IL|IN|IA|KS|KY|LA|ME|MH|MD|MA|MI|MN|MS|MO|MT|NE|NV|NH|NJ|NM|NY|NC|ND|MP|OH|OK|OR|PW|PA|PR|RI|SC|SD|TN|TX|UT|VT|VI|VA|WA|WV|WI|WY)$'
 * */

class TextFieldWithValidation extends React.Component {
  constructor(props) {
    super(props);
    this.state = { isInvalid: false }
  }

  isInvalid = (e) => {
    var result = false;
    const field = document.getElementById(this.props.id);
    const value = field.value;
    if (this.props.pattern || this.props.required) {
      // Check both the HTML validity field and pattern match results
      const pattern = new RegExp(this.props.pattern);
      result = (field.validity.valid && pattern.test(value)) ? false : true;
      if (result && this.props.onInvalid && typeof(this.props.onInvalid) === 'function') {
        this.props.onInvalid(e);
      }
    }
    this.setState({isInvalid: result});
    return result;
  }

  onChange = (event) => {

    var isInvalid = false;

    if (this.props.required || this.props.pattern) {
      isInvalid = this.isInvalid(event);
    }

    if(this.props.onChange) {
      this.props.onChange(event);
    }

    if(this.props.handleInputChange) {
      this.props.handleInputChange(event, isInvalid);
    }
  }

  render() {
    const { classes, visible, pattern, gridItemProps, id, name, type, error, helperText, handleInputChange, ...rest } = this.props;
    return(
      <div className={visible ? null : classes.hidden}>
        <Grid item {...gridItemProps}>
          <TextField
            id={id}
            name={name}
            type={type}
            pattern={pattern}
            error={this.state.isInvalid === 'undefined' ? error : this.state.isInvalid}
            helperText={this.state.isInvalid ? this.props.message : helperText}
            onChange={this.onChange}
            SelectProps={{
              classes: { 
                icon: classes.selectIcon 
              },
              SelectDisplayProps: {
                style: {
                  paddingRight: '20px',
                  textOverflow: 'clip',
                },
              },
              MenuProps: {
                style: {
                  maxHeight: '300px',
                }
              }
            }}
            {...rest}
          />
        </Grid>
      </div>
    )
  }
}

TextFieldWithValidation.propTypes = {
  classes: PropTypes.object.isRequired,
  visible: PropTypes.bool,
  pattern: PropTypes.string,
  message: (props, propName, componentName) => { 
    if ((props['required'] || props['pattern']) && (props[propName] === undefined || typeof(props[propName]) !== 'string')) {
      return new Error('textFieldProps message is a required prop if required or pattern props are true.')
    }
  },
  handleInputChange: PropTypes.func,
  onInvalid: PropTypes.func,
  gridItemProps: PropTypes.object,
};

const styles = theme => ({
  hidden: {
    display: 'none'
  }
})

export default withStyles(styles, {withTheme: true})(observer(TextFieldWithValidation));
